/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgZapOff(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M.47.47a.75.75 0 011.06 0l6.995 6.994a.758.758 0 01.012.012l7.988 7.988.012.012 6.993 6.994a.75.75 0 11-1.06 1.06l-6.42-6.419-4.474 5.37a.75.75 0 01-1.32-.574l.894-7.157H3a.75.75 0 01-.576-1.23l4.561-5.474L.47 1.53a.75.75 0 010-1.06zM8.05 9.11L4.601 13.25H12a.75.75 0 01.223.034L8.05 9.111zm4.666 4.666a.751.751 0 01.028.316l-.682 5.462 2.923-3.509-2.269-2.27zm.582-12.465a.75.75 0 01.446.78l-.59 4.75a.75.75 0 01-1.488-.184l.274-2.212-.793.954a.75.75 0 11-1.153-.96l2.43-2.92a.75.75 0 01.874-.208zM14.91 10a.75.75 0 01.75-.75H21a.75.75 0 01.576 1.23l-2.43 2.91a.75.75 0 11-1.152-.96l1.403-1.68H15.66a.75.75 0 01-.75-.75z'
        />
      </g>
      <defs>
        <clipPath id='zap-off_svg__clip0_126_10315'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgZapOff;
